/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Active ou désactive la validation des devis du tunnel.
 * @export
 * @interface SetValidationRequiseCommand
 */
export interface SetValidationRequiseCommand {
    /**
     * 
     * @type {boolean}
     * @memberof SetValidationRequiseCommand
     */
    validationRequise: boolean;
}

/**
 * Check if a given object implements the SetValidationRequiseCommand interface.
 */
export function instanceOfSetValidationRequiseCommand(value: object): value is SetValidationRequiseCommand {
    if (!('validationRequise' in value) || value['validationRequise'] === undefined) return false;
    return true;
}

export function SetValidationRequiseCommandFromJSON(json: any): SetValidationRequiseCommand {
    return SetValidationRequiseCommandFromJSONTyped(json, false);
}

export function SetValidationRequiseCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetValidationRequiseCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'validationRequise': json['validationRequise'],
    };
}

export function SetValidationRequiseCommandToJSON(json: any): SetValidationRequiseCommand {
    return SetValidationRequiseCommandToJSONTyped(json, false);
}

export function SetValidationRequiseCommandToJSONTyped(value?: SetValidationRequiseCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validationRequise': value['validationRequise'],
    };
}

